// Hooks
import { useState } from 'react';

// React Router
import { useNavigate } from 'react-router-dom';

// MUI
import { Box, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Button, TextField } from '@mui/material';
import EditDocumentIcon from '@mui/icons-material/EditDocument';

export default function Edit() {
    const navigate = useNavigate();

    const [gender, setGender] = useState(localStorage.getItem("gender") || "male");
    const [username, setUsername] = useState(localStorage.getItem("username") || "Ali Hassan");
    const [age, setAge] = useState(localStorage.getItem("age") || "49");

    const handleEdit = () => {
        let realAge = parseInt(age);
        setAge(`${realAge}`);
        const ageNumber = parseInt(age, 10);
        if (isNaN(ageNumber) || ageNumber < 10 || ageNumber > 100) {
            alert("Age must be a number between 10 and 100");
            return;
        }

        localStorage.setItem("username", username);
        localStorage.setItem("age", age);
        localStorage.setItem("gender", gender);

        navigate("../profile");
        window.location.reload();
    };

    return (
        <Box sx={{ display: "flex", gap: "20px", flexDirection: "column" }}>
            <Box sx={{ display: "flex", gap: "20px", flexDirection: { xs: "column", sm: "row" } }}>
                <Box sx={{ display: "flex", gap: "20px", flexDirection: "column" }}>
                    <TextField autoComplete='off' value={username}
                        onChange={(e) => {
                            setUsername(e.target.value);
                        }}
                        id="outlined-basic" label="Username" variant="outlined" />
                    <TextField autoComplete='off' value={age}
                        onChange={(e) => {
                            setAge(e.target.value);
                        }}
                        id="outlined-basic" label="Age" variant="outlined" />
                </Box>
                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={gender}
                        name="radio-buttons-group"
                        onChange={(e) => setGender(e.target.value)}
                    >
                        <FormControlLabel value="male" control={<Radio />} label="Male" />
                        <FormControlLabel value="female" control={<Radio />} label="Female" />
                    </RadioGroup>
                </FormControl>
            </Box>
            <Button onClick={() => {
                handleEdit();
            }} variant="contained" endIcon={<EditDocumentIcon />}>
                Submit
            </Button>
        </Box>
    )
}
